import { Separator } from '@talentmesh/ui/components/separator';
import { TypographyH3 } from '@talentmesh/ui/components/typography';
import { Briefcase, Mail } from 'lucide-react';
import InstructionItem from './InstructionItem';
import UIStrings from '@/Utils/UIStrings';

function Instructions() {
    return (
        <div className="bg-card flex flex-col gap-4">
            <TypographyH3>{`${UIStrings.InsertIn}:`}</TypographyH3>
            <div className="flex flex-row md:flex-row md:gap-0">
                <div className="min-w-0 flex-1">
                    <InstructionItem
                        icon={<Briefcase className="text-secondary-foreground size-4" />}
                        header={UIStrings.JobAds}
                        instruction={UIStrings.JobAdsInsertInstructions}
                    />
                </div>
                <Separator orientation="vertical" className="mx-8 min-h-24 self-stretch md:block" />
                <div className="min-w-0 flex-1">
                    <InstructionItem
                        icon={<Mail className="text-secondary-foreground size-4" />}
                        header={UIStrings.CustomInvitationEmail}
                        instruction={UIStrings.CustomInvitationEmailInstructions}
                    />
                </div>
            </div>
        </div>
    );
}

export default Instructions;
